/**
 * Routes that load Elevar tracking.
 *
 * These are the Zafira Organics advertorials only. BareEarth grounding sheet
 * pages ("/", "/adv-1", "/adv-3") and Glokore red light pages ("/rlt-1",
 * "/rlt-2") are intentionally excluded.
 *
 * Add a route here to start tracking it; remove it to stop.
 */
export const elevarTrackedRoutes = ['/glp1-investigation', '/glp1-investigation-b', '/glp1-investigation-c', '/glp1-investigation-d', '/glp1-investigation-e', '/glp-adv-1', '/glp-adv-2', '/glp-adv-3', '/glp-adv-4', '/glp-adv-5', '/glp-adv-6', '/glp-6-tips', '/glp-6-tips-b', '/glp-6-tips-c', '/glp-6-tips-d', '/glp-6-tips-e', '/glp-6-tips-f', '/glp-6-tips-g', '/glp-plateau-1', '/glp-plateau-2', '/glp-plateau-3', '/glp-plateau-4'];
